export const GET_FAVOURITES_INIT = "GET_FAVOURITES_INIT";
export const GET_FAVOURITES_SUCCESS = "GET_FAVOURITES_SUCCESS";
export const UPDATE_FAVOURITE = "favourites/UPDATE_FAVOURITE";
export const UPDATE_DATA_IN_FAVOURITE = "UPDATE_DATA_IN_FAVOURITE";
